// ==========================================
// src/i18n/translations.js - VERSÃO FINAL
// ==========================================

export const TRANSLATIONS = {
  en: {
    cookie_title: "We use cookies!",
    cookie_text: "This website uses cookies to ensure you get the best experience.",
    disclosure_label: "Disclosure:",
    disclosure_text: "We are an affiliate website. We do not sell or ship products. Purchases, warranty, and support are provided exclusively on the official website.",
    cta_label: "Go to Official Site",
    learn_more: "Learn more",
    decline: "Decline",
    accept: "Accept",
    privacy: "Privacy",
    contact: "Contact",
    official_support: "Official Support",
    free_shipping: "Free Shipping",
    money_back_guarantee: "Money Back Guarantee",
    customer_reviews: "Customer Reviews",
    special_bundles: "Special Bundles",
    faq: "FAQ",
    benefits: "Benefits",
    features: "Features",
    guarantee: "Guarantee",
    shipping: "Shipping",
    support: "Support",
  },
  pt: {
    cookie_title: "Usamos cookies!",
    cookie_text: "Este site usa cookies para garantir que você tenha a melhor experiência.",
    disclosure_label: "Aviso:",
    disclosure_text: "Somos um site de afiliados. Não vendemos nem enviamos produtos. Compras, garantia e suporte são fornecidos exclusivamente no site oficial.",
    cta_label: "Ir para o Site Oficial",
    learn_more: "Saiba mais",
    decline: "Recusar",
    accept: "Aceitar",
    privacy: "Privacidade",
    contact: "Contato",
    official_support: "Suporte Oficial",
    free_shipping: "Frete Grátis",
    money_back_guarantee: "Garantia de Devolução",
    customer_reviews: "Avaliações de Clientes",
    special_bundles: "Pacotes Especiais",
    faq: "Perguntas Frequentes",
    benefits: "Benefícios",
    features: "Recursos",
    guarantee: "Garantia",
    shipping: "Envio",
    support: "Suporte",
  },
  es: {
    cookie_title: "¡Usamos cookies!",
    cookie_text: "Este sitio web utiliza cookies para garantizar que obtenga la mejor experiencia.",
    disclosure_label: "Aviso:",
    disclosure_text: "Somos un sitio web de afiliados. No vendemos ni enviamos productos. Las compras, garantía y soporte se proporcionan exclusivamente en el sitio web oficial.",
    cta_label: "Ir al Sitio Oficial",
    learn_more: "Más información",
    decline: "Rechazar",
    accept: "Aceptar",
    privacy: "Privacidad",
    contact: "Contacto",
    official_support: "Soporte Oficial",
    free_shipping: "Envío Gratis",
    money_back_guarantee: "Garantía de Devolución",
    customer_reviews: "Opiniones de Clientes",
    special_bundles: "Paquetes Especiales",
    faq: "Preguntas Frecuentes",
    benefits: "Beneficios",
    features: "Características",
    guarantee: "Garantía",
    shipping: "Envío",
    support: "Soporte",
  },
  fr: {
    cookie_title: "Nous utilisons des cookies!",
    cookie_text: "Ce site web utilise des cookies pour vous garantir la meilleure expérience.",
    disclosure_label: "Avis:",
    disclosure_text: "Nous sommes un site web d'affiliation. Nous ne vendons ni n'expédions de produits. Les achats, la garantie et le support sont fournis exclusivement sur le site officiel.",
    cta_label: "Aller au site officiel",
    learn_more: "En savoir plus",
    decline: "Refuser",
    accept: "Accepter",
    privacy: "Confidentialité",
    contact: "Contact",
    official_support: "Support Officiel",
    free_shipping: "Livraison Gratuite",
    money_back_guarantee: "Garantie de Remboursement",
    customer_reviews: "Avis des Clients",
    special_bundles: "Forfaits Spéciaux",
    faq: "FAQ",
    benefits: "Avantages",
    features: "Fonctionnalités",
    guarantee: "Garantie",
    shipping: "Livraison",
    support: "Support",
  },
  de: {
    cookie_title: "Wir verwenden Cookies!",
    cookie_text: "Diese Website verwendet Cookies, um Ihnen die beste Erfahrung zu gewährleisten.",
    disclosure_label: "Offenlegung:",
    disclosure_text: "Wir sind eine Affiliate-Website. Wir verkaufen oder versenden keine Produkte. Käufe, Garantie und Support werden ausschließlich auf der offiziellen Website bereitgestellt.",
    cta_label: "Zur offiziellen Website",
    learn_more: "Mehr erfahren",
    decline: "Ablehnen",
    accept: "Akzeptieren",
    privacy: "Datenschutz",
    contact: "Kontakt",
    official_support: "Offizieller Support",
    free_shipping: "Kostenloser Versand",
    money_back_guarantee: "Geld-zurück-Garantie",
    customer_reviews: "Kundenbewertungen",
    special_bundles: "Sonderpakete",
    faq: "FAQ",
    benefits: "Vorteile",
    features: "Funktionen",
    guarantee: "Garantie",
    shipping: "Versand",
    support: "Support",
  },
  it: {
    cookie_title: "Utilizziamo i cookie!",
    cookie_text: "Questo sito web utilizza i cookie per garantirti la migliore esperienza.",
    disclosure_label: "Informativa:",
    disclosure_text: "Siamo un sito web di affiliazione. Non vendiamo né spediamo prodotti. Acquisti, garanzia e supporto sono forniti esclusivamente sul sito ufficiale.",
    cta_label: "Vai al sito ufficiale",
    learn_more: "Per saperne di più",
    decline: "Rifiuta",
    accept: "Accetta",
    privacy: "Privacy",
    contact: "Contatto",
    official_support: "Supporto Ufficiale",
    free_shipping: "Spedizione Gratuita",
    money_back_guarantee: "Garanzia Soddisfatti o Rimborsati",
    customer_reviews: "Recensioni Clienti",
    special_bundles: "Pacchetti Speciali",
    faq: "Domande Frequenti",
    benefits: "Vantaggi",
    features: "Caratteristiche",
    guarantee: "Garanzia",
    shipping: "Spedizione",
    support: "Supporto",
  },
};

export const LANGUAGE_OPTIONS = [
  { code: "en", name: "English",    flag: "🇺🇸", nativeName: "English"    },
  { code: "pt", name: "Português",  flag: "🇧🇷", nativeName: "Português"  },
  { code: "es", name: "Español",    flag: "🇪🇸", nativeName: "Español"    },
  { code: "fr", name: "Français",   flag: "🇫🇷", nativeName: "Français"   },
  { code: "de", name: "Deutsch",    flag: "🇩🇪", nativeName: "Deutsch"    },
  { code: "it", name: "Italiano",   flag: "🇮🇹", nativeName: "Italiano"   },
];

// ==========================================
// LIMITES DO GOOGLE ADS
// ==========================================

export const GOOGLE_ADS_LIMITS = {
  HEADLINE: 30,
  DESCRIPTION: 90,
  SITELINK_TEXT: 25,
  SITELINK_DESC: 35,
  CALLOUT: 25,
  STRUCTURED_SNIPPET_VALUE: 25,
  PRICE_EXTENSION_ITEM: 25,
  PROMOTION_TITLE: 30,
};

// ==========================================
// TEMPLATES PARA GOOGLE ADS
//
// Fixes aplicados vs versão anterior:
//
// DUPLICATAS CORRIGIDAS:
//   1. only_price = buy_price_per_bottle em PT/ES/FR/DE/IT
//      → only_price agora usa "{product} {percent}% OFF {currency}{price}" (inclui %)
//      → garantido ser diferente pois tem o percentual
//
//   2. free_fast_shipping = free_fast_shipping_short em FR e IT
//      → free_fast_shipping agora é mais descritivo em FR/IT
//      → FR: "Livraison Rapide Gratuite" vs "Livraison Gratuite"
//      → IT: "Spedizione Rapida Gratuita" vs "Spedizione Gratuita"
//
//   3. save_up_to = special_promo_off em PT/ES/FR/DE/IT
//      → special_promo_off agora tem estrutura diferente de save_up_to
//      → save_up_to: "Economize {amount}" (valor puro)
//      → special_promo_off: "{amount} OFF Hoje/Hoy/..." (ordem e sufixo diferentes)
//      → Combinado com amount2 override no ProductForm → valores sempre diferentes
//
//   4. EN special_promo_off: "Save {amount} Off" era redundante
//      → Corrigido para "{currency}{amount} Off Today"
// ==========================================

export const AD_TEMPLATES = {
  en: {
    // ── Headlines (max 30 chars) ──────────────────────────────────────────
    official_site:            "{product} Official Site",          // ~18-24
    buy_price_per_bottle:     "Buy {product} {currency}{price}",  // ~17-23 — com "Buy"
    special_offer:            "{product} Special",                // ~16-21
    save_up_to:               "Save {currency}{amount}",          // ~9-14   — usa amount (savings_1)
    only_price:               "{product} {percent}% Off {currency}{price}", // ~22-28 — diferente de buy_price
    percent_off:              "{product} {percent}% Off",         // ~14-19
    free_fast_shipping:       "Free Fast Shipping",               // 18
    special_promo_off:        "{currency}{amount} Off Today",     // ~14-18  — usa amount2, distinto de save_up_to
    buy_direct_factory:       "Buy Direct From Factory",          // 23
    special_offer_today:      "Special Offer Today",              // 19
    free_fast_shipping_short: "Free Shipping",                    // 13      — menor que free_fast_shipping
    limited_time:             "Limited Time Offer",               // 18
    price_free_ship:          "{currency}{price} + Free Ship",    // ~15-20
    buy_now_today:            "Buy {currency}{price} Today",      // ~13-18
    buy_discount:             "{currency}{amount} Discount",      // ~12-17  — usa amount2

    // ── Descriptions (max 90 chars) ───────────────────────────────────────
    desc_1: "Buy {product} Only {currency}{price}. Free Shipping Today On Official Website",
    desc_2: "Save {currency}{amount}. Order {product} Free Shipping. Only {currency}{price}",
    desc_3: "Feel Great With {product}. Order With Discount + {days} Days Money Back",
    desc_4: "{product} {percent}% Off + Free Shipping {currency}{price} Per Bottle Today",
    desc_5: "{product} {currency}{price} + Free Ship. {days} Days 100% Guarantee",

    // ── Sitelinks ─────────────────────────────────────────────────────────
    sitelink_buy_now:          "Buy Now",
    sitelink_guarantee:        "Money Back Guarantee",
    sitelink_reviews:          "Customer Reviews",
    sitelink_shipping:         "Free Shipping",
    sitelink_bundles:          "Special Bundles",
    sitelink_faq:              "FAQ",
    sitelink_buy_desc1:        "Official Site With Discount",
    sitelink_buy_desc2:        "Free Shipping Worldwide",
    sitelink_guarantee_desc1:  "{days} Days Guarantee",
    sitelink_guarantee_desc2:  "No Questions Asked Refund",
    sitelink_reviews_desc1:    "See What Customers Say",
    sitelink_reviews_desc2:    "10,000+ Positive Reviews",
    sitelink_shipping_desc1:   "Fast and Secure Delivery",
    sitelink_shipping_desc2:   "Worldwide Free Shipping",
    sitelink_bundles_desc1:    "Save More With Bundles",
    sitelink_bundles_desc2:    "{currency}{price} Per Bottle",
    sitelink_faq_desc1:        "All Questions Answered",
    sitelink_faq_desc2:        "Read Common Questions",

    // ── Callouts (max 25 chars) ───────────────────────────────────────────
    callout_shipping:  "Free Worldwide Shipping",
    callout_guarantee: "{days} Days Money Back",
    callout_secure:    "100% Secure Website",
    callout_support:   "24/7 Customer Support",

    // ── Price Extensions ──────────────────────────────────────────────────
    price_bottles: "{qty} Bottles",

    // ── Structured Snippet ────────────────────────────────────────────────
    snippet_benefits: "Types",
    snippet_values: ["Fast Delivery", "Warranty", "24/7 Support", "Free Shipping"],

    // ── Keywords ─────────────────────────────────────────────────────────
    kw_product:           "{product}",
    kw_buy_product:       "buy {product}",
    kw_product_price:     "{product} price",
    kw_product_official:  "{product} official site",
    kw_product_discount:  "{product} discount",
    kw_product_reviews:   "{product} reviews",
    kw_order_product:     "order {product}",
    kw_product_where_buy: "{product} where to buy",
    kw_product_online:    "{product} online",
    kw_best_price:        "best price {product}",
    negative_keywords: ['free', 'scam', 'fake', 'pirate', 'torrent', 'crack'],
  },

  pt: {
    // ── Headlines (max 30 chars) ──────────────────────────────────────────
    official_site:            "{product} Site Oficial",           // ~22-27
    buy_price_per_bottle:     "Compre {product} {currency}{price}", // ~20-26 — com "Compre"
    special_offer:            "{product} Oferta Especial",        // ~22-27
    save_up_to:               "Economize {currency}{amount}",     // ~18-22  — usa amount
    only_price:               "{product} {percent}% OFF {currency}{price}", // diferente de buy_price
    percent_off:              "{product} {percent}% OFF",         // ~14-19
    free_fast_shipping:       "Frete Grátis Expresso",            // 21      — diferente do short
    special_promo_off:        "{currency}{amount} OFF Hoje",      // ~15-18  — usa amount2, distinto
    buy_direct_factory:       "Compre Direto Da Fábrica",         // 24
    special_offer_today:      "Oferta Especial Hoje",             // 20
    free_fast_shipping_short: "Frete Grátis",                     // 12      — menor
    limited_time:             "Oferta Por Tempo Limitado",        // 25
    price_free_ship:          "{currency}{price} + Frete Grátis", // ~19-23
    buy_now_today:            "Compre {currency}{price} Hoje",    // ~17-20
    buy_discount:             "{currency}{amount} De Desconto",   // ~20-23  — usa amount2

    // ── Descriptions ──────────────────────────────────────────────────────
    desc_1: "Compre {product} {currency}{price}. Frete Grátis Hoje No Site Oficial",
    desc_2: "Economize {currency}{amount}. Peça {product} Frete Grátis. {currency}{price}",
    desc_3: "{product}. Peça Com Desconto + {days} Dias Garantia De Devolução",
    desc_4: "{product} {percent}% OFF + Frete Grátis {currency}{price} Por Frasco Hoje",
    desc_5: "{product} {currency}{price} + Frete Grátis. {days} Dias Garantia 100%",

    // ── Sitelinks ─────────────────────────────────────────────────────────
    sitelink_buy_now:          "Compre Agora",
    sitelink_guarantee:        "Garantia De Devolução",
    sitelink_reviews:          "Avaliações De Clientes",
    sitelink_shipping:         "Frete Grátis",
    sitelink_bundles:          "Pacotes Especiais",
    sitelink_faq:              "FAQ",
    sitelink_buy_desc1:        "Site Oficial Com Desconto",
    sitelink_buy_desc2:        "Frete Grátis Para Todo Brasil",
    sitelink_guarantee_desc1:  "{days} Dias De Garantia",
    sitelink_guarantee_desc2:  "Reembolso Sem Perguntas",
    sitelink_reviews_desc1:    "Veja O Que Clientes Dizem",
    sitelink_reviews_desc2:    "10.000+ Avaliações Positivas",
    sitelink_shipping_desc1:   "Entrega Rápida E Segura",
    sitelink_shipping_desc2:   "Frete Grátis Para Todo O País",
    sitelink_bundles_desc1:    "Economize Com Pacotes",
    sitelink_bundles_desc2:    "{currency}{price} Por Frasco",
    sitelink_faq_desc1:        "Perguntas Respondidas",
    sitelink_faq_desc2:        "Leia As Perguntas Comuns",

    // ── Callouts ─────────────────────────────────────────────────────────
    callout_shipping:  "Frete Grátis Brasil",
    callout_guarantee: "{days} Dias Garantia",
    callout_secure:    "Site 100% Seguro",
    callout_support:   "Suporte 24/7",

    // ── Price Extensions ──────────────────────────────────────────────────
    price_bottles: "{qty} Frascos",

    // ── Structured Snippet ────────────────────────────────────────────────
    snippet_benefits: "Types",
    snippet_values: ["Entrega Rápida", "Garantia", "Suporte 24/7", "Frete Grátis"],

    // ── Keywords ─────────────────────────────────────────────────────────
    kw_product:           "{product}",
    kw_buy_product:       "comprar {product}",
    kw_product_price:     "{product} preço",
    kw_product_official:  "{product} site oficial",
    kw_product_discount:  "{product} desconto",
    kw_product_reviews:   "{product} avaliações",
    kw_order_product:     "pedir {product}",
    kw_product_where_buy: "{product} onde comprar",
    kw_product_online:    "{product} online",
    kw_best_price:        "melhor preço {product}",
    negative_keywords: ['grátis', 'gratuito', 'golpe', 'falso', 'pirata', 'torrent', 'crack'],
  },

  es: {
    // ── Headlines (max 30 chars) ──────────────────────────────────────────
    official_site:            "{product} Sitio Oficial",
    buy_price_per_bottle:     "Compre {product} {currency}{price}", // com "Compre"
    special_offer:            "{product} Oferta Especial",
    save_up_to:               "Ahorre {currency}{amount}",
    only_price:               "{product} {percent}% OFF {currency}{price}",
    percent_off:              "{product} {percent}% OFF",
    free_fast_shipping:       "Envío Gratis Rápido",
    special_promo_off:        "{currency}{amount} OFF Hoy",        // usa amount2
    buy_direct_factory:       "Compre Directo De Fábrica",
    special_offer_today:      "Oferta Especial Hoy",
    free_fast_shipping_short: "Envío Gratis",
    limited_time:             "Oferta Por Tiempo Limitado",
    price_free_ship:          "{currency}{price} + Envío Gratis",
    buy_now_today:            "Compre {currency}{price} Hoy",
    buy_discount:             "{currency}{amount} De Descuento",   // usa amount2

    // ── Descriptions ──────────────────────────────────────────────────────
    desc_1: "Compre {product} {currency}{price}. Envío Gratis Hoy En Sitio Oficial",
    desc_2: "Ahorre {currency}{amount}. Pida {product} Envío Gratis. {currency}{price}",
    desc_3: "{product}. Pida Con Descuento + {days} Días Garantía De Devolución",
    desc_4: "{product} {percent}% OFF + Envío Gratis {currency}{price} Por Botella Hoy",
    desc_5: "{product} {currency}{price} + Envío Gratis. {days} Días Garantía 100%",

    // ── Sitelinks ─────────────────────────────────────────────────────────
    sitelink_buy_now:          "Comprar Ahora",
    sitelink_guarantee:        "Garantía De Devolución",
    sitelink_reviews:          "Opiniones De Clientes",
    sitelink_shipping:         "Envío Gratis",
    sitelink_bundles:          "Paquetes Especiales",
    sitelink_faq:              "FAQ",
    sitelink_buy_desc1:        "Sitio Oficial Con Descuento",
    sitelink_buy_desc2:        "Envío Gratis Mundial",
    sitelink_guarantee_desc1:  "{days} Días De Garantía",
    sitelink_guarantee_desc2:  "Reembolso Sin Preguntas",
    sitelink_reviews_desc1:    "Vea Lo Que Dicen Clientes",
    sitelink_reviews_desc2:    "10,000+ Opiniones Positivas",
    sitelink_shipping_desc1:   "Entrega Rápida Y Segura",
    sitelink_shipping_desc2:   "Envío Gratis Para Todo El País",
    sitelink_bundles_desc1:    "Ahorre Con Paquetes",
    sitelink_bundles_desc2:    "{currency}{price} Por Botella",
    sitelink_faq_desc1:        "Preguntas Respondidas",
    sitelink_faq_desc2:        "Lea Las Preguntas Comunes",

    // ── Callouts ─────────────────────────────────────────────────────────
    callout_shipping:  "Envío Gratis Mundial",
    callout_guarantee: "{days} Días Garantía",
    callout_secure:    "Sitio 100% Seguro",
    callout_support:   "Soporte 24/7",

    // ── Price Extensions ──────────────────────────────────────────────────
    price_bottles: "{qty} Botellas",

    // ── Structured Snippet ────────────────────────────────────────────────
    snippet_benefits: "Types",
    snippet_values: ["Entrega Rápida", "Garantía", "Soporte 24/7", "Envío Gratis"],

    // ── Keywords ─────────────────────────────────────────────────────────
    kw_product:           "{product}",
    kw_buy_product:       "comprar {product}",
    kw_product_price:     "{product} precio",
    kw_product_official:  "{product} sitio oficial",
    kw_product_discount:  "{product} descuento",
    kw_product_reviews:   "{product} opiniones",
    kw_order_product:     "pedir {product}",
    kw_product_where_buy: "{product} dónde comprar",
    kw_product_online:    "{product} online",
    kw_best_price:        "mejor precio {product}",
    negative_keywords: ['gratis', 'gratuito', 'estafa', 'falso', 'pirata', 'torrent', 'crack'],
  },

  fr: {
    // ── Headlines (max 30 chars) ──────────────────────────────────────────
    official_site:            "{product} Site Officiel",
    buy_price_per_bottle:     "Achetez {product} {currency}{price}", // com "Achetez"
    special_offer:            "{product} Offre Spéciale",
    save_up_to:               "Économisez {currency}{amount}",
    only_price:               "{product} {percent}% OFF {currency}{price}",
    percent_off:              "{product} {percent}% OFF",
    free_fast_shipping:       "Livraison Rapide Gratuite",          // DIFERENTE do short
    special_promo_off:        "{currency}{amount} OFF Aujourd'hui", // usa amount2
    buy_direct_factory:       "Achetez Direct Usine",
    special_offer_today:      "Offre Spéciale Aujourd'hui",
    free_fast_shipping_short: "Livraison Gratuite",                 // short
    limited_time:             "Offre À Durée Limitée",
    price_free_ship:          "{currency}{price} Livr. Gratuite",
    buy_now_today:            "Achetez {currency}{price} Maintenant",
    buy_discount:             "{currency}{amount} De Réduction",    // usa amount2

    // ── Descriptions ──────────────────────────────────────────────────────
    desc_1: "Achetez {product} {currency}{price}. Livraison Gratuite Sur Site Officiel",
    desc_2: "Économisez {currency}{amount}. {product} Livraison Gratuite. {currency}{price}",
    desc_3: "{product}. Commandez Avec Réduction + {days} Jours Garantie Remboursement",
    desc_4: "{product} {percent}% OFF + Livraison Gratuite {currency}{price} Par Bouteille",
    desc_5: "{product} {currency}{price} + Livraison Gratuite. {days} Jours Garantie",

    // ── Sitelinks ─────────────────────────────────────────────────────────
    sitelink_buy_now:          "Acheter Maintenant",
    sitelink_guarantee:        "Garantie Remboursement",
    sitelink_reviews:          "Avis Des Clients",
    sitelink_shipping:         "Livraison Gratuite",
    sitelink_bundles:          "Forfaits Spéciaux",
    sitelink_faq:              "FAQ",
    sitelink_buy_desc1:        "Site Officiel Avec Réduction",
    sitelink_buy_desc2:        "Livraison Gratuite Mondiale",
    sitelink_guarantee_desc1:  "{days} Jours De Garantie",
    sitelink_guarantee_desc2:  "Remboursement Sans Questions",
    sitelink_reviews_desc1:    "Voyez Les Avis Des Clients",
    sitelink_reviews_desc2:    "10 000+ Avis Positifs",
    sitelink_shipping_desc1:   "Livraison Rapide Et Sécurisée",
    sitelink_shipping_desc2:   "Livraison Gratuite Mondiale",
    sitelink_bundles_desc1:    "Économisez Avec Les Forfaits",
    sitelink_bundles_desc2:    "{currency}{price} Par Bouteille",
    sitelink_faq_desc1:        "Toutes Les Questions Répondues",
    sitelink_faq_desc2:        "Lisez Les Questions Courantes",

    // ── Callouts ─────────────────────────────────────────────────────────
    callout_shipping:  "Livraison Gratuite",
    callout_guarantee: "{days} Jours Garantie",
    callout_secure:    "Site 100% Sécurisé",
    callout_support:   "Support 24/7",

    // ── Price Extensions ──────────────────────────────────────────────────
    price_bottles: "{qty} Bouteilles",

    // ── Structured Snippet ────────────────────────────────────────────────
    snippet_benefits: "Types",
    snippet_values: ["Livraison Rapide", "Garantie", "Support 24/7", "Livraison Gratuite"],

    // ── Keywords ─────────────────────────────────────────────────────────
    kw_product:           "{product}",
    kw_buy_product:       "acheter {product}",
    kw_product_price:     "{product} prix",
    kw_product_official:  "{product} site officiel",
    kw_product_discount:  "{product} réduction",
    kw_product_reviews:   "{product} avis",
    kw_order_product:     "commander {product}",
    kw_product_where_buy: "{product} où acheter",
    kw_product_online:    "{product} en ligne",
    kw_best_price:        "meilleur prix {product}",
    negative_keywords: ['gratuit', 'arnaque', 'faux', 'pirate', 'torrent', 'crack'],
  },

  de: {
    // ── Headlines (max 30 chars) ──────────────────────────────────────────
    official_site:            "{product} Offizielle Website",
    buy_price_per_bottle:     "Kaufen {product} {currency}{price}", // com "Kaufen"
    special_offer:            "{product} Sonderangebot",
    save_up_to:               "Sparen Sie {currency}{amount}",
    only_price:               "{product} {percent}% RABATT {currency}{price}",
    percent_off:              "{product} {percent}% RABATT",
    free_fast_shipping:       "Schneller Kostenloser Versand",     // DIFERENTE do short
    special_promo_off:        "{currency}{amount} RABATT Heute",   // usa amount2
    buy_direct_factory:       "Direkt Vom Hersteller Kaufen",
    special_offer_today:      "Sonderangebot Heute",
    free_fast_shipping_short: "Kostenloser Versand",               // short
    limited_time:             "Zeitlich Begrenztes Angebot",
    price_free_ship:          "{currency}{price} Gratis Versand",
    buy_now_today:            "Kaufen {currency}{price} Heute",
    buy_discount:             "{currency}{amount} Preisnachlass",  // usa amount2

    // ── Descriptions ──────────────────────────────────────────────────────
    desc_1: "Kaufen {product} {currency}{price}. Kostenloser Versand Auf Offizieller Website",
    desc_2: "Sparen {currency}{amount}. {product} Kostenloser Versand. {currency}{price}",
    desc_3: "{product}. Bestellen Mit Rabatt + {days} Tage Geld-Zurück-Garantie",
    desc_4: "{product} {percent}% RABATT + Kostenloser Versand {currency}{price} Pro Flasche",
    desc_5: "{product} {currency}{price} + Kostenloser Versand. {days} Tage Garantie",

    // ── Sitelinks ─────────────────────────────────────────────────────────
    sitelink_buy_now:          "Jetzt Kaufen",
    sitelink_guarantee:        "Geld-Zurück-Garantie",
    sitelink_reviews:          "Kundenbewertungen",
    sitelink_shipping:         "Kostenloser Versand",
    sitelink_bundles:          "Sonderpakete",
    sitelink_faq:              "FAQ",
    sitelink_buy_desc1:        "Offizielle Website Mit Rabatt",
    sitelink_buy_desc2:        "Kostenloser Weltweiter Versand",
    sitelink_guarantee_desc1:  "{days} Tage Garantie",
    sitelink_guarantee_desc2:  "Rückerstattung Ohne Fragen",
    sitelink_reviews_desc1:    "Sehen Was Kunden Sagen",
    sitelink_reviews_desc2:    "10.000+ Positive Bewertungen",
    sitelink_shipping_desc1:   "Schnelle Und Sichere Lieferung",
    sitelink_shipping_desc2:   "Weltweiter Kostenloser Versand",
    sitelink_bundles_desc1:    "Sparen Mit Paketen",
    sitelink_bundles_desc2:    "{currency}{price} Pro Flasche",
    sitelink_faq_desc1:        "Alle Fragen Beantwortet",
    sitelink_faq_desc2:        "Häufige Fragen Lesen",

    // ── Callouts ─────────────────────────────────────────────────────────
    callout_shipping:  "Kostenloser Versand",
    callout_guarantee: "{days} Tage Geld-Zurück",
    callout_secure:    "100% Sichere Website",
    callout_support:   "24/7 Kundensupport",

    // ── Price Extensions ──────────────────────────────────────────────────
    price_bottles: "{qty} Flaschen",

    // ── Structured Snippet ────────────────────────────────────────────────
    snippet_benefits: "Types",
    snippet_values: ["Schnelle Lieferung", "Garantie", "24/7 Support", "Gratis Versand"],

    // ── Keywords ─────────────────────────────────────────────────────────
    kw_product:           "{product}",
    kw_buy_product:       "{product} kaufen",
    kw_product_price:     "{product} preis",
    kw_product_official:  "{product} offizielle website",
    kw_product_discount:  "{product} rabatt",
    kw_product_reviews:   "{product} bewertungen",
    kw_order_product:     "{product} bestellen",
    kw_product_where_buy: "{product} wo kaufen",
    kw_product_online:    "{product} online",
    kw_best_price:        "bester preis {product}",
    negative_keywords: ['kostenlos', 'gratis', 'betrug', 'gefälscht', 'pirat', 'torrent', 'crack'],
  },

  it: {
    // ── Headlines (max 30 chars) ──────────────────────────────────────────
    official_site:            "{product} Sito Ufficiale",
    buy_price_per_bottle:     "Acquista {product} {currency}{price}", // com "Acquista"
    special_offer:            "{product} Offerta Speciale",
    save_up_to:               "Risparmia {currency}{amount}",
    only_price:               "{product} {percent}% OFF {currency}{price}",
    percent_off:              "{product} {percent}% OFF",
    free_fast_shipping:       "Spedizione Rapida Gratuita",          // DIFERENTE do short
    special_promo_off:        "{currency}{amount} OFF Oggi",          // usa amount2
    buy_direct_factory:       "Acquista Diretto Dal Produttore",
    special_offer_today:      "Offerta Speciale Oggi",
    free_fast_shipping_short: "Spedizione Gratuita",                 // short
    limited_time:             "Offerta A Tempo Limitato",
    price_free_ship:          "{currency}{price} Spediz. Gratis",
    buy_now_today:            "Acquista {currency}{price} Oggi",
    buy_discount:             "{currency}{amount} Di Sconto",         // usa amount2

    // ── Descriptions ──────────────────────────────────────────────────────
    desc_1: "Acquista {product} {currency}{price}. Spedizione Gratuita Sul Sito Ufficiale",
    desc_2: "Risparmia {currency}{amount}. {product} Spedizione Gratuita. {currency}{price}",
    desc_3: "{product}. Ordina Con Sconto + {days} Giorni Garanzia Soddisfatti O Rimborsati",
    desc_4: "{product} {percent}% OFF + Spedizione Gratuita {currency}{price} Per Bottiglia",
    desc_5: "{product} {currency}{price} + Spedizione Gratuita. {days} Giorni Garanzia",

    // ── Sitelinks ─────────────────────────────────────────────────────────
    sitelink_buy_now:          "Acquista Ora",
    sitelink_guarantee:        "Garanzia Rimborso",
    sitelink_reviews:          "Recensioni Clienti",
    sitelink_shipping:         "Spedizione Gratuita",
    sitelink_bundles:          "Pacchetti Speciali",
    sitelink_faq:              "FAQ",
    sitelink_buy_desc1:        "Sito Ufficiale Con Sconto",
    sitelink_buy_desc2:        "Spedizione Gratuita Mondiale",
    sitelink_guarantee_desc1:  "{days} Giorni Di Garanzia",
    sitelink_guarantee_desc2:  "Rimborso Senza Domande",
    sitelink_reviews_desc1:    "Vedi Cosa Dicono I Clienti",
    sitelink_reviews_desc2:    "10.000+ Recensioni Positive",
    sitelink_shipping_desc1:   "Consegna Rapida E Sicura",
    sitelink_shipping_desc2:   "Spedizione Gratuita Mondiale",
    sitelink_bundles_desc1:    "Risparmia Con I Pacchetti",
    sitelink_bundles_desc2:    "{currency}{price} Per Bottiglia",
    sitelink_faq_desc1:        "Tutte Le Domande Risposta",
    sitelink_faq_desc2:        "Leggi Le Domande Comuni",

    // ── Callouts ─────────────────────────────────────────────────────────
    callout_shipping:  "Spedizione Gratuita",
    callout_guarantee: "{days} Giorni Garanzia",
    callout_secure:    "Sito 100% Sicuro",
    callout_support:   "Supporto 24/7",

    // ── Price Extensions ──────────────────────────────────────────────────
    price_bottles: "{qty} Bottiglie",

    // ── Structured Snippet ────────────────────────────────────────────────
    snippet_benefits: "Types",
    snippet_values: ["Consegna Rapida", "Garanzia", "Supporto 24/7", "Spedizione Gratis"],

    // ── Keywords ─────────────────────────────────────────────────────────
    kw_product:           "{product}",
    kw_buy_product:       "acquistare {product}",
    kw_product_price:     "{product} prezzo",
    kw_product_official:  "{product} sito ufficiale",
    kw_product_discount:  "{product} sconto",
    kw_product_reviews:   "{product} recensioni",
    kw_order_product:     "ordinare {product}",
    kw_product_where_buy: "{product} dove comprare",
    kw_product_online:    "{product} online",
    kw_best_price:        "miglior prezzo {product}",
    negative_keywords: ['gratis', 'gratuito', 'truffa', 'falso', 'pirata', 'torrent', 'crack'],
  },
};

// ==========================================
// STRUCTURED SNIPPET HEADERS POR IDIOMA
// ==========================================

export const SNIPPET_HEADERS = {
  en: {
    AMENITIES: 'Amenities', BRANDS: 'Brands', STYLES: 'Styles', TYPES: 'Types',
    SERVICES: 'Service catalog', DESTINATIONS: 'Destinations', MODELS: 'Models',
    NEIGHBORHOODS: 'Neighborhoods', SHOWS: 'Shows', COURSES: 'Courses',
    DEGREE_PROGRAMS: 'Degree programs', FEATURED_HOTELS: 'Featured hotels',
    INSURANCE_COVERAGE: 'Insurance coverage',
  },
  pt: {
    AMENITIES: 'Comodidades', BRANDS: 'Marcas', STYLES: 'Estilos', TYPES: 'Tipos',
    SERVICES: 'Serviços', DESTINATIONS: 'Destinos', MODELS: 'Modelos',
    NEIGHBORHOODS: 'Bairros', SHOWS: 'Programas', COURSES: 'Cursos',
    DEGREE_PROGRAMS: 'Programas de graduação', FEATURED_HOTELS: 'Hotéis em destaque',
    INSURANCE_COVERAGE: 'Cobertura de seguro',
  },
  es: {
    AMENITIES: 'Servicios adicionales', BRANDS: 'Marcas', STYLES: 'Estilos', TYPES: 'Tipos',
    SERVICES: 'Servicios adicionales', DESTINATIONS: 'Destinos', MODELS: 'Modelos',
    NEIGHBORHOODS: 'Barrios', SHOWS: 'Programas', COURSES: 'Cursos',
    DEGREE_PROGRAMS: 'Programas de titulación', FEATURED_HOTELS: 'Hoteles destacados',
    INSURANCE_COVERAGE: 'Cobertura de seguro',
  },
  fr: {
    AMENITIES: 'Équipements', BRANDS: 'Marques', STYLES: 'Styles', TYPES: 'Types',
    SERVICES: 'Services', DESTINATIONS: 'Destinations', MODELS: 'Modèles',
    NEIGHBORHOODS: 'Quartiers', SHOWS: 'Émissions', COURSES: 'Cours',
    DEGREE_PROGRAMS: 'Programmes', FEATURED_HOTELS: 'Hôtels en vedette',
    INSURANCE_COVERAGE: "Couverture d'assurance",
  },
  de: {
    AMENITIES: 'Ausstattung', BRANDS: 'Marken', STYLES: 'Stile', TYPES: 'Typen',
    SERVICES: 'Dienstleistungen', DESTINATIONS: 'Ziele', MODELS: 'Modelle',
    NEIGHBORHOODS: 'Viertel', SHOWS: 'Serien', COURSES: 'Kurse',
    DEGREE_PROGRAMS: 'Studiengänge', FEATURED_HOTELS: 'Vorgestellte Hotels',
    INSURANCE_COVERAGE: 'Versicherungsleistung',
  },
  it: {
    AMENITIES: 'Servizi', BRANDS: 'Brand', STYLES: 'Stili', TYPES: 'Tipi',
    SERVICES: 'Servizi', DESTINATIONS: 'Destinazioni', MODELS: 'Modelli',
    NEIGHBORHOODS: 'Quartieri', SHOWS: 'Programmi', COURSES: 'Corsi',
    DEGREE_PROGRAMS: 'Programmi di laurea', FEATURED_HOTELS: 'Hotel in evidenza',
    INSURANCE_COVERAGE: 'Copertura assicurativa',
  },
};

// ==========================================
// HELPERS
// ==========================================

export const truncateText = (text, maxLength) => {
  if (!text) return '';
  return text.length <= maxLength ? text : text.substring(0, maxLength);
};

export const fillTemplate = (template, vars) => {
  if (!template) return '';
  return template.replace(/\{(\w+)\}/g, (match, key) => vars[key] !== undefined ? vars[key] : match);
};

export const validateHeadline    = (t) => truncateText(t, GOOGLE_ADS_LIMITS.HEADLINE);
export const validateDescription = (t) => truncateText(t, GOOGLE_ADS_LIMITS.DESCRIPTION);
export const validateSitelinkText = (t) => truncateText(t, GOOGLE_ADS_LIMITS.SITELINK_TEXT);
export const validateSitelinkDesc = (t) => truncateText(t, GOOGLE_ADS_LIMITS.SITELINK_DESC);
export const validateCallout      = (t) => truncateText(t, GOOGLE_ADS_LIMITS.CALLOUT);
export const validateSnippetValue = (t) => truncateText(t, GOOGLE_ADS_LIMITS.STRUCTURED_SNIPPET_VALUE);
export const validatePriceItem    = (t) => truncateText(t, GOOGLE_ADS_LIMITS.PRICE_EXTENSION_ITEM);
export const validatePromotionTitle = (t) => truncateText(t, GOOGLE_ADS_LIMITS.PROMOTION_TITLE);

export const getTranslation = (languageCode, key) => {
  const lang = TRANSLATIONS[languageCode] || TRANSLATIONS.en;
  return lang[key] || TRANSLATIONS.en[key] || key;
};
export const getAllTranslations = (languageCode) => TRANSLATIONS[languageCode] || TRANSLATIONS.en;
export const getLanguageInfo = (languageCode) => LANGUAGE_OPTIONS.find(l => l.code === languageCode) || LANGUAGE_OPTIONS[0];
export const isValidLanguage = (languageCode) => LANGUAGE_OPTIONS.some(l => l.code === languageCode);